"use client";
import { TextGenerateEffect } from "../@/components/ui/text-generate-effect";
 
const words = `The Computer Society of India (CSI) Club at VIT-AP originated as one of the first clubs and chapters at VIT-AP to give students with opportunities to work on computer science issues outside of the classroom. Our members are provided with training and requirements to help students achieve in their positions in the technology arena.
`;
 
export function TextGenerateEffectDemo() {
  return <TextGenerateEffect words={words} />;
}

export default TextGenerateEffectDemo;
